import outdent from "outdent";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oneTrust = defineConnector({
  identifier: "oneTrust",
  name: "OneTrust",
  tagLine: "Privacy and GRC platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.onetrust\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content: outdent`
            1. Log in to your OneTrust instance
            2. Navigate to **Global Settings > Access Management > Client Credentials**
            3. Select **Add New** to create a new credential
            4. Copy the **Client ID** and **Client Secret** (the secret is shown only once)
          `,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Hostname",
          required: true,
          placeholder: "mycompany.onetrust.com",
          helperText: "Your OneTrust hostname (e.g. app.onetrust.com).",
          target: { kind: "configuration", field: "hostname" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ hostname }) =>
      `https://${hostname}/api/access/v1/oauth/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ hostname }) => ({
      url: `https://${hostname}/api/access/v1/oauth/discovery`,
      expectedStatus: [200, 403],
    }),
  },
  publicEnvVars: ({ hostname }) => ({
    ONE_TRUST_URL: hostname ? `https://${hostname}` : "",
  }),
});
